import React, { useEffect, useReducer, useState } from 'react';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import EditIcon from '@material-ui/icons/Edit';
import { Button, IconButton, TextField } from '@material-ui/core';
import './KeyValuePairList.scss';
import CustomTextField from '../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate } from '../../utils/formUtils';

const KeyValuePairList = (props) => {
  const { item, onListChange } = props;
  const [isUniqueInfo, setUniqueInfo] = useState(true);
  const [customAttributes, setCustomAttributes] = useState([]);
  const [editMode, setEditMode] = useState({ isEdit: false, editIndex: -1 });

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    key: {
      value: '',
      fieldName: 'Enter Label Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    value: {
      value: '',
      fieldName: 'Field Value',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
  });

  useEffect(() => {
    setCustomAttributes(item.value);
  }, [item.value]);

  const onCustomAttributeAdd = () => {
    if (validate()) {
      const currList = [...customAttributes];
      const custAttribute = {
        key: formData.key.value,
        value: formData.value.value,
      };

      if (editMode?.isEdit) {
        const isDuplicate = currList?.some(
          (e, i) =>
            i !== editMode?.editIndex &&
            e.key === formData?.key?.value &&
            e.value === formData?.value?.value,
        );
        if (isDuplicate) {
          setUniqueInfo(false);
          return;
        }
        const updateList = currList?.map((obj, i) => {
          return i === editMode?.editIndex ? custAttribute : obj;
        });
        setCustomAttributes(updateList);
        setEditMode({ isEdit: false, editIndex: -1 });
        const currField = { ...item };
        currField.value = updateList;
        onListChange(currField);
        resetFormData();
      } else {
        if (
          currList.some((e) => e.key === formData.key.value && e.value === formData.value.value)
        ) {
          setUniqueInfo(false);
        } else {
          currList.push(custAttribute);
          setUniqueInfo(true);
          setCustomAttributes(currList);
          const currField = { ...item };
          currField.value = currList;
          onListChange(currField);
          resetFormData();
        }
      }
    }
  };

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const onInfoEdit = (e, item, index) => {
    e.preventDefault();
    setEditMode({ isEdit: true, editIndex: index });
    const currFields = { ...formData };
    currFields.key.value = item.key;
    currFields.value.value = item.value;
    setFormData(currFields);
  };

  const resetFormData = () => {
    const currFields = { ...formData };
    currFields.key.value = '';
    currFields.value.value = '';
    setFormData(currFields);
  };

  const onInfoDelete = (index) => {
    const currList = [...customAttributes];
    currList.splice(index, 1);
    setCustomAttributes(currList);
    const currField = { ...item };
    currField.value = currList;
    onListChange(currField);
  };

  return (
    <div className='row'>
      <div className='col-md-12 mb-3'>
        <h4 className='tab-title'>Key Value Pair</h4>
        <div className='row'>
          <div className='col-md-6 mb-3'>
            <CustomTextField
              item={formData.key}
              handleInputChange={(e) => {
                setUniqueInfo(true);
                setFormData({ key: e });
              }}
              endAdornment={true}
              multiline={true}
            />
          </div>
          <div className='col-md-6 mb-3'>
            <CustomTextField
              item={formData.value}
              handleInputChange={(e) => {
                setUniqueInfo(true);
                setFormData({ value: e });
              }}
              endAdornment={true}
              multiline={true}
            />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12 mb-3'>
            {!isUniqueInfo && <div className='input-error'>Duplicate combination</div>}
            <Button
              variant='outlined'
              color={formData.value && formData.key ? 'primary' : 'secondary'}
              onClick={onCustomAttributeAdd}
            >
              {editMode.isEdit ? 'Update' : 'Add'}
            </Button>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12 mb-3 key-value-pair-list'>
            {customAttributes?.map((item, index) => (
              <div
                className='key-value-pair-list-item align-items-center p-2 d-flex justify-content-between'
                key={index}
              >
                <div className='w-100 '>
                  <div className='label-container'>
                    <label className='label'>{item?.key}</label>
                  </div>
                  <div className='value-container'>
                    <TextField
                      id='additional-info-field-edit'
                      className='w-100'
                      value={item?.value}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </div>
                </div>
                <div className='button-container d-flex'>
                  <IconButton
                    aria-label='edit'
                    disabled={editMode.isEdit}
                    onClick={(e) => onInfoEdit(e, item, index)}
                  >
                    <EditIcon fontSize='small' className='icon' />
                  </IconButton>
                  <IconButton aria-label='delete' onClick={(e) => onInfoDelete(index)}>
                    <RemoveCircleIcon fontSize='small' className='icon' />
                  </IconButton>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KeyValuePairList;
